// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tag_wrapper__1Iag3","title":"Tag_title__1yI_3","deleteIcon":"Tag_deleteIcon__sVjc7"};